import React, { useContext } from "react";
import toast from "react-hot-toast";
import { AuthContext } from "../../contexts/AuthContext";
import { CartContext } from "../../contexts/CartContext";

export default function ProductActions({
  quantity,
  item,
}: {
  quantity: number;
  item: any;
}) {
  const [qty, setQty] = React.useState(1);
  const { handleAddToCart, cartItems, handleRemoveFromCart } =
    useContext(CartContext);

  const handleIncrement = () => {
    if (qty >= quantity) {
      toast.error("You can't add more than available stock");
      return;
    }
    setQty(qty + 1);
  };

  const handleDecrement = () => {
    if (qty <= 1) {
      return;
    }
    setQty(qty - 1);
  };
  return (
    <div className="ec-single-qty">
      <div className="qty-plus-minus">
        <div className="dec ec_qtybtn" onClick={handleDecrement}>
          -
        </div>
        <input
          className="qty-input"
          type="text"
          name="ec_qtybtn"
          defaultValue={qty}
          value={qty}
        />
        <div className="inc ec_qtybtn" onClick={handleIncrement}>
          +
        </div>
      </div>
      <div className="ec-single-cart ">
        {cartItems.find((cartItem) => cartItem.productId === item.id) ? (
          <button
            className="btn btn-danger"
            onClick={() => {
              const cartItem: any = cartItems.find(
                (cartItem) => cartItem.productId === item.id
              );
              if (!cartItem) {
                return;
              }
              handleRemoveFromCart(cartItem?.id);
            }}
          >
            Remove From Cart
          </button>
        ) : (
          <button
            className="btn btn-primary"
            onClick={() => {
              handleAddToCart({ productId: item.id, quantity: qty });
            }}
          >
            Add To Cart
          </button>
        )}
      </div>
    </div>
  );
}
